export interface Brand {
  id:
    | 'travronden'
    | 'travronden_spel'
    | 'jokersystemet'
    | 'jokersystemet_no'
    | 'spelvarde'
    | 'kopandel'
    | 'overodds'
    | 'travfakta'
    | 'tackarr'
    | 'tr_auktion'
    | 'storavinster'
    | 'travogat'
    | 'tr_studio'
    | 'trmedia';
  name: string;
  href: string;
  text: string;
  logoEqualizationFactor: number;
  // Cloudinary id for the brand's logo image
  cdnId: string;
  // Cloudinary id for the brand's icon image
  iconId?: string;
  // Cloudinary id for the brand's tile image
  tileId?: string;
  darkMode?: {
    cdnId: string;
    iconId?: string;
    tileId?: string;
  };
}

// Note: When rendering some or all brand logos together scale the image by
// logoEqualizationFactor for a more balanced visual harmony.
const brands: Brand[] = [
  {
    id: 'travronden',
    name: 'Travronden',
    href: 'https://www.travronden.se',
    text: 'Travronden är ledande i Norden på travjournalistik och spel på hästar. Vi bevakar travsporten inifrån.',
    logoEqualizationFactor: 1,
    cdnId: 'brands/logos/knzepysus8klplehpxls',
    iconId: 'brands/icons/yhx4niqrfdihwhebzoxz',
    tileId: 'brands/tiles/mecxqpywjtdbmwh8tbsf',
  },
  {
    id: 'travronden_spel',
    name: 'Travronden Spel',
    href: 'https://www.travrondenspel.se',
    text: 'Den senaste spelinformationen till alla stora streckspel. V75 tips och V75 resultat. Det har aldrig varit enklare att bli en vinnare!',
    logoEqualizationFactor: 1.1,
    cdnId: 'brands/logos/g4mowgk8gkrnotnxh64o',
  },
  {
    id: 'jokersystemet',
    name: 'Jokersystemet',
    href: 'https://www.jokersystemet.se',
    text: 'Det kraftfullaste och mest omfattande verktyget på marknaden för reducering av trav- och sportspel.',
    logoEqualizationFactor: 0.9,
    cdnId: 'brands/logos/s0zxcrvtsom29anxstqp',
    iconId: 'brands/icons/rph8pkegw7v1nwb4ii9h',
    tileId: 'brands/tiles/hpju4pdospibtxayxvpn',
  },
  {
    id: 'jokersystemet_no',
    name: 'Jokersystemet',
    href: 'https://www.jokersystemet.no',
    text: 'Jokersystemet er verdens mest omfattende og beste verktøy for redusering av spill på trav. Over 7000 fornøyde abonnenter!',
    logoEqualizationFactor: 1,
    cdnId: 'brands/logos/i6driejcmhm6cqtwc9jg',
  },
  {
    id: 'spelvarde',
    name: 'Spelvärde',
    href: 'https://www.spelvarde.se',
    text: 'Tips från Sveriges främsta tipsters och travanalytiker. Vi spelar för att vinna stort!',
    logoEqualizationFactor: 0.9,
    cdnId: 'brands/logos/j5lilnoxuqaytf0yjf3l',
    iconId: 'brands/icons/l2gezf3oamjjxaqilmtr',
    tileId: 'brands/tiles/azowrbm1fhtxh5fyzwda',
  },
  {
    id: 'kopandel',
    name: 'Köpandel',
    href: 'https://www.kopandel.se',
    text: 'Andelsspel från landets främsta experter! På köpandel.se kan du ta rygg på Sveriges främsta tipsters till ATGs och Svenska Spels alla stora spelformer.',
    logoEqualizationFactor: 1,
    cdnId: 'brands/logos/ojuujdc3ukb2stqfklks',
    iconId: 'brands/icons/m5vj0loqx0tqcpyxylts',
    tileId: 'brands/tiles/ynd7ggnw5nsbpdys5ez6',
  },
  {
    id: 'overodds',
    name: 'Överodds',
    href: 'https://www.overodds.se',
    text: 'Hos oss hittar du spelrekar med utförliga analyser och landets mest genomarbetade Stryktipsmaterial.',
    logoEqualizationFactor: 1,
    cdnId: 'brands/logos/hcypg7ngquo2smawi3qt',
    iconId: 'brands/icons/putuf1voikqycekaszc3',
    tileId: 'brands/tiles/farkufftit0anas0mumu',
  },
  {
    id: 'travfakta',
    name: 'Travfakta',
    href: 'https://www.travfakta.se',
    text: 'Proffsens verktyg för att analysera travlopp! Travfakta.se är en databas med oändlig information om alla hästar, kuskar, tränare, banor, spelformer m.m.',
    logoEqualizationFactor: 1,
    cdnId: 'brands/logos/ktclq7hgvzagqvnivas9',
    iconId: 'brands/icons/hrbxocvoplqqcam0pqiu',
    tileId: 'brands/tiles/aaa0yabya9yxk9hqpuxo',
  },
  {
    id: 'tackarr',
    name: 'Tackarr',
    href: 'https://www.tackarr.se',
    text: 'Andelsspel som får fler att ta till sig hur kul det är med spel på trav & fotboll. På tackarr.se hittar du också dagliga tips, tävlingar & skönt snack om heta omgångar.',
    logoEqualizationFactor: 1,
    cdnId: 'brands/logos/n7roxyq9rnfahyggenlt',
  },
  {
    id: 'tr_auktion',
    name: 'TR Auktion',
    href: 'https://www.trauktion.se',
    text: 'TR Auktion erbjuder den bästa upplevelsen för både köpare och säljare och travsporten får vara med och dela på överskottet.',
    logoEqualizationFactor: 1,
    cdnId: 'brands/logos/gao4ek1lfc4zilz745bs',
  },
  {
    id: 'storavinster',
    name: 'Storavinster',
    href: 'https://www.storavinster.se',
    text: 'Sajten för dig som vill spela med statistiken i ryggen.',
    logoEqualizationFactor: 1,
    cdnId: 'brands/logos/q49qish6aatqdh8du96k',
    iconId: 'brands/icons/xn6lauqoiav6yaw5nons',
    tileId: 'brands/tiles/cjag8ovjw4o5mllbfi3e',
  },
  {
    id: 'travogat',
    name: 'Travögat',
    href: 'https://www.travogat.se',
    text: 'Snabbaste vägen till alla rätt! Unika tips i videoformat från en av Sveriges bästa travspelare.',
    logoEqualizationFactor: 0.9,
    cdnId: 'brands/logos/j8mpuro4mxlyuk3nn2t4',
    iconId: 'brands/icons/i5dtu2xmocrobw43nqob',
    tileId: 'brands/tiles/iwogoxyq8xqzyqfjzwry',
  },
  {
    id: 'tr_studio',
    name: 'TR Studio',
    href: 'https://www.trmedia.se/tr-studio',
    text: 'Med passion för bilden - Vi på TR Studio gillar nya utmaningar och bland det bästa vi vet är att få göra våra kunder nöjda!',
    logoEqualizationFactor: 1,
    cdnId: 'brands/logos/tch33angusckshn4f5zd',
  },
  {
    id: 'trmedia',
    name: 'TR Media',
    href: 'https://www.trmedia.se',
    text: 'Sveriges främsta varumärken för dig som älskar trav!',
    logoEqualizationFactor: 1,
    cdnId: 'brands/logos/si3okwhx7yghsm0fknwo',
    darkMode: {
      cdnId: 'brands/logos/eaf5nhunkde5jjmevlsj',
    },
  },
];

/**
 *
 * @param {string[] | string} [exclude]  - brand(s) to exclude, by name or id.
 * @param {string[] | string} [excludeById]  - brand(s) to exclude, by id only.
 * @returns A list of brand objects
 */
export const getBrands = ({
  exclude,
  excludeById,
}: {
  exclude?: string[] | string;
  excludeById?: string[] | string;
} = {}): Brand[] => {
  const excludeByNameOrIdList =
    exclude == null ? [] : Array.isArray(exclude) ? exclude : [exclude];
  const excludeByIdList =
    excludeById == null
      ? []
      : Array.isArray(excludeById)
        ? excludeById
        : [excludeById];

  if (excludeByNameOrIdList.length === 0 && excludeByIdList.length === 0) {
    return brands;
  }

  return brands
    .filter(brand =>
      excludeByNameOrIdList.every(
        nameOrId =>
          ![brand.id, brand.name.toLowerCase()].includes(
            nameOrId.toLowerCase(),
          ),
      ),
    )
    .filter(brand => !excludeByIdList.includes(brand.id));
};

/**
 *
 * @param {array|string} brand by name or id
 * @returns A brand object or undefined if not found
 */
export function getBrand(brandNameOrId: undefined | null): undefined;
export function getBrand(brandNameOrId: string): Brand;
export function getBrand(brandNameOrId: string | undefined | null) {
  if (brandNameOrId == null) {
    return;
  }
  return brands.find(brand =>
    [brand.id, brand.name.toLowerCase()].includes(brandNameOrId.toLowerCase()),
  );
}
